var _path, _path2, _rect, _rect2, _path3, _rect3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNexusDashboardSanController(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,10.75A29.28292,29.28292,0,0,1,69.25,40h1.5a30.75,30.75,0,0,0-61.5,0h1.5A29.28292,29.28292,0,0,1,40,10.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56,55.25H50.63281a2.73292,2.73292,0,0,0-5.26562,0H24v1.5H45.36719a2.73292,2.73292,0,0,0,5.26562,0H56Zm-8,2A1.25,1.25,0,1,1,49.25,56,1.25116,1.25116,0,0,1,48,57.25Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 27.25,
    width: 12,
    height: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 35.25,
    width: 12,
    height: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.75,48V24a.7502.7502,0,0,0-.75-.75H24a.7502.7502,0,0,0-.75.75V48a.7502.7502,0,0,0,.75.75H56A.7502.7502,0,0,0,56.75,48Zm-1.5-.75H24.75v-6.5h30.5Zm0-8H24.75v-6.5h30.5Zm0-8H24.75v-6.5h30.5Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 43.25,
    width: 12,
    height: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32,59.25a2.74452,2.74452,0,0,0-2.63281,2H24v1.5h5.36719a2.73292,2.73292,0,0,0,5.26562,0H56v-1.5H34.63281A2.74452,2.74452,0,0,0,32,59.25Zm0,4A1.25,1.25,0,1,1,33.25,62,1.25116,1.25116,0,0,1,32,63.25Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 28,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 36,
    r: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 36,
    r: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 44,
    r: 1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 44,
    r: 1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 44,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNexusDashboardSanController);
export default __webpack_public_path__ + "static/media/icon_nexus_dashboard_san_controller.a1c66c2255da5e3013bfc90090b22c6c.svg";
export { ForwardRef as ReactComponent };